function initMenuDrawerFixed() {
    const isDesktop = window.innerWidth >= 1024;
    const toggleButtons = document.querySelectorAll('.menu-drawer-fixed__toggle-btn');
    const menuContents = document.querySelectorAll('.menu-drawer-fixed__menu');
    const menuHamburgerButton = document.querySelector('.menu-drawer-container summary.header__icon');

    const INITIAL_DELAY = 500;
    const ANIMATION_DURATION = 1000;
    const STORAGE_KEY = 'menu-drawer-selected-menu';
    let animationTimeouts = [];

    // End cycling animation on user hover
    const allMenuItems = document.querySelectorAll(
      '.menu-drawer-fixed__menu a.list-menu__item'
    );

    allMenuItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        stopAllAnimations();
      });
    });


    // Animate items
    function animateMenuItemsSequentially(menu) {
      const menuItems = menu.querySelectorAll('a.list-menu__item');

      menuItems.forEach(item => item.classList.remove('animate-reveal'));
      animationTimeouts.forEach(timeout => clearTimeout(timeout));
      animationTimeouts = [];

      const initialTimeout = setTimeout(() => {
        menuItems.forEach((item, index) => {
          const itemTimeout = setTimeout(() => {
            if (index > 0) {
              menuItems[index - 1].classList.remove('animate-reveal');
            }

            item.classList.add('animate-reveal');

            if (index === menuItems.length - 1) {
              const lastItemTimeout = setTimeout(() => {
                item.classList.remove('animate-reveal');
              }, ANIMATION_DURATION);
              animationTimeouts.push(lastItemTimeout);
            }
          }, index * ANIMATION_DURATION);

          animationTimeouts.push(itemTimeout);
        });
      }, INITIAL_DELAY);
  
      animationTimeouts.push(initialTimeout);
    }
  
    // Stop animations
    function stopAllAnimations() {
      animationTimeouts.forEach(timeout => clearTimeout(timeout));
      animationTimeouts = [];
  
      const allMenuItems = document.querySelectorAll('.menu-drawer-fixed__menu a.list-menu__item');
      allMenuItems.forEach(item => item.classList.remove('animate-reveal'));
    }
  
    // Observe drawer open/close
    const drawerDetails = document.querySelector('#Details-menu-drawer-container-fixed');
    if (drawerDetails) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (drawerDetails.hasAttribute('open')) {
              const activeMenu = document.querySelector('.menu-drawer-fixed__menu--active');
              if (activeMenu) animateMenuItemsSequentially(activeMenu);
            } else {
              stopAllAnimations();
            }
          }
        });
      });
  
      observer.observe(drawerDetails, { attributes: true });
    }
  
    // Toggle buttons
    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
  
        const targetMenu = this.getAttribute('data-menu');
        switchToMenu(targetMenu);
      });
    });
  
    // Desktop hover toggle
    if (isDesktop) {
      const toggleOnHover = document.querySelector('.menu-drawer-container')?.getAttribute('data-toggle-menu-on-hover');
      let eventlistenerAdded = false;
  
      if (toggleOnHover && !eventlistenerAdded) {  
        menuHamburgerButton.addEventListener('mouseenter', function () {
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
  
          if (!isExpanded) {
            this.click();
  
            const drawer = document.querySelector('.menu-drawer-fixed');
            if (drawer && eventlistenerAdded === false) {
              drawer.addEventListener('mouseleave', function () {
                menuHamburgerButton.click();
              });
            }
          }
  
          eventlistenerAdded = true;
        });
      }
    }

    // Restore menu on page load
    function restoreLastSelectedMenu() {
      const selectedMenu = sessionStorage.getItem(STORAGE_KEY);
      if (selectedMenu && (selectedMenu === 'main' || selectedMenu === 'secondary')) {
        switchToMenu(selectedMenu);
      }
    }

    restoreLastSelectedMenu();

    // Close menu when mobile close button is clicked
    const menuDrawerCloseBtnMobile = document.querySelector('.menu-drawer-close-btn-mobile');
    if (menuDrawerCloseBtnMobile) {
      menuDrawerCloseBtnMobile.addEventListener('click', function () {
        const menuDrawer = document.querySelector('.menu-drawer-fixed');
        if (menuDrawer) {
          menuHamburgerButton.click();
        }
      });
    }

    function switchToMenu(targetMenu) {
      sessionStorage.setItem(STORAGE_KEY, targetMenu);

      toggleButtons.forEach(btn => btn.classList.remove('menu-drawer-fixed__toggle-btn--active'));
      const activeButton = document.querySelector(`.menu-drawer-fixed__toggle-btn[data-menu="${targetMenu}"]`);

      if (activeButton) {
        activeButton.classList.add('menu-drawer-fixed__toggle-btn--active');
      }

      const toggleContainer = document.querySelector('.menu-drawer-fixed__toggle');

      if (toggleContainer) {
        toggleContainer.classList.remove('toggle-active-main', 'toggle-active-secondary');
        toggleContainer.classList.add(targetMenu === 'main' ? 'toggle-active-main' : 'toggle-active-secondary');
      }

      menuContents.forEach(menu => {
        const type = menu.getAttribute('data-menu-content');
        if (type === targetMenu) {
          menu.style.display = 'block';
          menu.classList.add('menu-drawer-fixed__menu--active');
          animateMenuItemsSequentially(menu);
        } else {
          menu.style.display = 'none';
          menu.classList.remove('menu-drawer-fixed__menu--active');
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initMenuDrawerFixed);
